import React from 'react';
import { Fieldset, SectionHeading } from '@vwfs-bronson/bronson-react';

interface Props {
  heading: string;
  center?: boolean;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  infoIcon?: any;
}

export const Question: React.FC<Props> = (props) => {
  const { heading, infoIcon, children, center = true } = props;

  return (
    <Fieldset className='u-mv-large'>
      <SectionHeading level={2} infoIcon={infoIcon} center={center} className='u-mb-large text-center'>
        {heading}
      </SectionHeading>
      {children}
    </Fieldset>
  );
};
